import JSum from 'jsum';

const Checksum = function (object) {
    return JSum.digest(object, 'SHA256', 'hex');
};

export default Checksum;
